import {
    FETCH_ORDERS_REQUEST,
    FETCH_ORDERS_SUCCESS,
    FETCH_ORDERS_FAILURE,
    APPEND_ORDERS_REQUEST,
    APPEND_ORDERS_SUCCESS,
    APPEND_ORDERS_FAILURE,
    FETCH_ORDER_REQUEST,
    FETCH_ORDER_SUCCESS,
    FETCH_ORDER_FAILURE,
    UPDATE_ORDER_REQUEST,
    UPDATE_ORDER_SUCCESS,
    UPDATE_ORDER_FAILURE,
    CANCEL_ORDER_REQUEST,
    CANCEL_ORDER_SUCCESS,
    CANCEL_ORDER_FAILURE,
    CLEAR_ORDER_ERRORS,
    REMOVE_ORDER_FROM_LIST
  } from '../actions/orderActions';

  const initialState = {
    orders: null,
    order: null,
    loading: false,
    loadingMore: false,
    hasMore: false,
    error: null
  };
  
  // Reducer
  const orderReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_ORDERS_REQUEST:
      case FETCH_ORDER_REQUEST:
      case UPDATE_ORDER_REQUEST:
      case CANCEL_ORDER_REQUEST:
        return {
          ...state,
          loading: true,
          error: null
        };
      
      case FETCH_ORDERS_SUCCESS:
        return {
          ...state,
          orders: action.payload,
          loading: false,
          hasMore: action.payload.pagination.page < action.payload.pagination.pages,
          error: null
        };

      case APPEND_ORDERS_REQUEST:
        return { ...state, loadingMore: true, error: null };

      case APPEND_ORDERS_SUCCESS:
        return {
          ...state,
          orders: {
            ...action.payload,
            items: [...(state.orders?.items || []), ...action.payload.items]
          },
          loadingMore: false,
          hasMore: action.payload.pagination.page < action.payload.pagination.pages,
          error: null
        };

      case APPEND_ORDERS_FAILURE:
        return { ...state, loadingMore: false, error: action.payload };
      
      case FETCH_ORDER_SUCCESS:
        return {
          ...state,
          order: action.payload,
          loading: false,
          error: null
        };
      
      case UPDATE_ORDER_SUCCESS:
      case CANCEL_ORDER_SUCCESS:
        return {
          ...state,
          orders: state.orders ? {
            ...state.orders,
            items: state.orders.items?.map(order =>
              order.id === action.payload.id ? action.payload : order
            )
          } : state.orders,
          order: action.payload,
          loading: false,
          error: null
        };
      
      case FETCH_ORDERS_FAILURE:
      case FETCH_ORDER_FAILURE:
      case UPDATE_ORDER_FAILURE:
      case CANCEL_ORDER_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload
        };
      
      case CLEAR_ORDER_ERRORS:
        return {
          ...state,
          error: null
        };

      case REMOVE_ORDER_FROM_LIST:
        return {
          ...state,
          orders: state.orders ? {
            ...state.orders,
            items: state.orders.items?.filter(order => order.id !== action.payload)
          } : state.orders
        };

      default:
        return state;
    }
  };
  
  export default orderReducer;